/**
 * Layout configuration constants
 */

export const LAYOUT_CONFIG = {
    SIDEBAR_WIDTH: 280,
    TOP_NAV_HEIGHT: 64,
    TOP_SPACING: 16,
} as const;
